import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import PropertyPicker from './components/PropertyPicker';
import PropertyDropdown from './components/PropertyDropdown';
import { Trans } from 'react-i18next';

class AuxSettings extends BaseFeature {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    render() {
        const auxAp = this.props.properties["aux.ap"];
        const aux_iuvp = this.props.properties["aux.iuvp"];
        const aux_iuvr = this.props.properties["aux.iuvr"];
        const aux_iovp = this.props.properties["aux.iovp"];
        const aux_iovr = this.props.properties["aux.iovr"];

        const hasInputVoltage = aux_iuvp && aux_iuvr && aux_iovp && aux_iovr;

        return (
            <><Row>
                <Col sm={4} style={{minWidth: '600px'}}>
                    <Card className="card-feature-component" style={{ width: '80%'}}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Auxiliary_Voltage_Selection" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertyDropdown
                                property={auxAp}
                                properties={auxAp.valueMeta.availableValues}
                                title={auxAp.info.displayName + ` (V)`}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    {hasInputVoltage &&
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Input_Voltage" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col></Col>
                                <Col>{<Trans i18nKey="Protection" />}</Col>
                                <Col>{<Trans i18nKey="Recovery" />}</Col>
                            </Row>
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.1rem'}}>
                                <Col className="d-flex align-items-center">{<Trans i18nKey="Under_Voltage" />}</Col>
                                <Col>
                                    <PropertyPicker
                                        property={aux_iuvp}
                                        margin="0.75rem auto"
                                        inputPadding={'padding-none'}
                                        measureUnit={'V'}
                                        min={aux_iuvp.valueMeta.min}
                                        max={aux_iuvp.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                                <Col>
                                    <PropertyPicker
                                        property={aux_iuvr}
                                        margin="0.75rem auto"
                                        inputPadding={'padding-none'}
                                        measureUnit={'V'}
                                        min={aux_iuvr.valueMeta.min}
                                        max={aux_iuvr.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                            </Row>
                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.1rem'}}>
                                <Col className="d-flex align-items-center">{<Trans i18nKey="Over_Voltage" />}</Col>
                                <Col>
                                    <PropertyPicker
                                        property={aux_iovp}
                                        margin="0.75rem auto"
                                        inputPadding={'padding-none'}
                                        measureUnit={'V'}
                                        min={aux_iovp.valueMeta.min}
                                        max={aux_iovp.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                                <Col>
                                    <PropertyPicker
                                        property={aux_iovr}
                                        margin="0.75rem auto"
                                        inputPadding={'padding-none'}
                                        measureUnit={'V'}
                                        min={aux_iovr.valueMeta.min}
                                        max={aux_iovr.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    }
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(AuxSettings);
